import React, { useRef, useState } from "react";
import { DialogContainer } from "react-md";
import FontIcon from "react-md/lib/FontIcons";
import EventService from "../../../../../../service/event/EventService";
import CartDashboardUtils from "../../services/CartDashboardUtils";

/**
 * "Marked on hold" success dialog shown after a successful POST /hold.
 *
 *  - Resume order → POST /resume → onResumed(updatedCart) so the screen can
 *    swap state back to PENDING_REVIEW without leaving.
 *  - Done → onDone() (typically exits to the dashboard which then refreshes).
 *
 * Errors fall through to a toast; the dialog stays open so the reviewer can
 * retry or hit Done.
 */
const MarkOnHoldSuccessDialog = ({ visible, cartId, onResumed, onDone }) => {
  const cartDashboardUtils = useRef(new CartDashboardUtils()).current;
  const [resuming, setResuming] = useState(false);

  const handleResume = () => {
    if (resuming) return;
    setResuming(true);
    cartDashboardUtils.resumeCart(
      cartId,
      (res) => {
        setResuming(false);
        if (onResumed) onResumed(res);
      },
      (err) => {
        setResuming(false);
        EventService.emit("showError", {
          message: `Failed to resume order: ${err?.message || "Unknown error"}`,
        });
      },
    );
  };

  return (
    <DialogContainer
      id="cart-mark-on-hold-success-dialog"
      visible={visible}
      onHide={onDone}
      focusOnMount={false}
      width={"560px"}
      autosizeContent={true}
      dialogStyle={{ borderRadius: "10px" }}
      modal
    >
      <div className="mhsd-container">
        <div className="mhsd-icon">
          <div className="mhsd-icon-outer">
            <div className="mhsd-icon-inner">
              <FontIcon style={{ fontSize: "44px", color: "#fff" }}>
                check
              </FontIcon>
            </div>
          </div>
        </div>
        <h2 className="mhsd-title">Marked on hold</h2>

        <div className="mhsd-footer">
          <button
            type="button"
            className="mhsd-btn mhsd-btn--resume"
            onClick={handleResume}
            disabled={resuming}
          >
            {resuming ? "Resuming…" : "Resume order"}
          </button>
          <button
            type="button"
            className="mhsd-btn mhsd-btn--done"
            onClick={onDone}
            disabled={resuming}
          >
            Done
          </button>
        </div>
      </div>
    </DialogContainer>
  );
};

export default MarkOnHoldSuccessDialog;
